import React, {forwardRef, useImperativeHandle, useRef, useState} from "react";
import {getImagePathWithTheme, hasLicense, imgPathPerfix} from "../../utils";
import {Button, Checkbox, Select, type SelectProps, Tag} from "antd";
import {getUserInfo} from "@/api/Api";
import Global from "@/global";
import {useTranslation} from "react-i18next";
import {IconDropdownBlack} from "@/Icon";

let mszNoteId;


const PopverExport = forwardRef((props:{onClosePopover:any,onDoneEvent:any}, ref)=>{
    useImperativeHandle(ref,()=>({
        onDialogShow:onDialogShow,
        onGetIsSelectOpened:onGetIsSelectOpened
    }))
    const {t} = useTranslation();
    type TagRender = SelectProps['tagRender'];
    const [selectDefaultValues,setSelectDefaultValues] = useState([]);
    const [arrayPages,setArrayPages]=useState([]);
    const [isSelectOpened,setIsSelectOpened] = useState(false);
    const [exportType,setExportType] = useState('png');

    const onDialogShow = (szNoteId:string,arrayMenuDatas:any,arraySelectKeys:any,exportType:any)=>{
        mszNoteId = szNoteId;
        setExportType(exportType)
        //get all page...
        var arrayPages:any = [];
        let szCurrentKey:string = '';
        if (arraySelectKeys?.length > 0){
            szCurrentKey = arraySelectKeys[0];
        }
        let arraySelectedValues:any = [];
        let currentPage:any;
        let arrayNewMenuDatas:any = [...arrayMenuDatas];

        for (var i=0;i<arrayNewMenuDatas.length;i++){
            var item = arrayNewMenuDatas[i];
            if (item.isFolder){
                for (var j=0;j<item.children.length;j++){
                    var page = item.children[j];
                    if (page.key === szCurrentKey){
                        currentPage = page;
                        page.isChecked = true;
                    }else{
                        page.isChecked = false;
                    }
                    arrayPages.push({
                        ...page,
                        label:page.title,
                        value:page.key
                    });
                }
            }else{
                if (item.key === szCurrentKey){
                    currentPage = item;
                    item.isChecked = true;
                }else{
                    item.isChecked = false;
                }
                arrayPages.push({
                    ...item,
                    label:item.title,
                    value:item.key
                });
            }
        }

        //添加到默认选择.
        arraySelectedValues.push(currentPage?.key);

        //first.
        arrayPages.splice(0,0,{
            title:t("All boards")+"(1-"+arrayPages.length+")",
            key:'all'
        },{
            ...currentPage,
            title:t("Current board")+"("+currentPage?.title+")",
            key:currentPage?.key+1,
            extra:true,
            isChecked:true
        })
        setArrayPages(arrayPages);
        setSelectDefaultValues(arraySelectedValues);
    }

    const onGetIsSelectOpened = ()=>{
        return isSelectOpened;
    }

    const reanderTag:TagRender = (props)=>{
        const { label, value, closable, onClose } = props;
        const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
            // event.preventDefault();
            // event.stopPropagation();
        };
        return (
            <Tag
                onMouseDown={onPreventMouseDown}
                closable={false}
                onClose={onClose}
                style={{ marginRight: 3 ,backgroundColor:'var(--tag-background-color)',borderRadius:'4px',border:'none',color:'var(--text-color)'}}
            >
                {label}
            </Tag>
        );
    }

    /*下拉更改*/
    const onSelectPageItemClicked = (e)=>{
        const szKey = e.currentTarget.dataset.key;
        var arrayNewPages = [...arrayPages];

        let isChecked = false;

        let arraySelectKeys:any = [];
        let isCheckAll = true;
        for (let i=0;i<arrayNewPages.length;i++){
            var item:any = arrayNewPages[i];

            if (item.key.startsWith(szKey) || szKey.startsWith(item.key)){
                item.isChecked = !item.isChecked;
                isChecked = item.isChecked;
            }

            if (szKey === 'all'){
                //all
                item.isChecked = isChecked;
            }

            if (item.key != 'all' && !item.isChecked){
                isCheckAll = false;
            }

            if (item.isChecked && !item.extra && item.key !== 'all'){
                arraySelectKeys.push(item.key);
            }
        }
        arrayNewPages[0].isChecked = isCheckAll;

        setArrayPages(arrayNewPages);
        setSelectDefaultValues(arraySelectKeys);
    }

    /**
     * 当前选中的条目
     */
    const getSelectedPages = ()=>{
        let arraySelectPages = [];
        //前2个不算....
        for (let i=2;i<arrayPages.length;i++) {
            var item = arrayPages[i];
            if (item.isChecked && item.key !== 'all'){
                arraySelectPages.push(item);
            }
        }
        return arraySelectPages;
    }

    return(
        <div className='flex-col font-size-12'>
            <div className='flex-row-vertical-center'>
                <img className='img-16' src={getImagePathWithTheme((exportType==='png'?"menu_export_as_png":"menu_export_as_pdf"))}/>
                <span className='ml-8 font-family-medium'>{exportType === 'png'?t("Output png"):t("Export as Pdf")}</span>
            </div>
            <Select
                suffixIcon={<IconDropdownBlack/>}
                tagRender={reanderTag}
                showSearch={false}
                mode="multiple"
                size={'middle'}
                open={isSelectOpened}
                onDropdownVisibleChange={(e)=>{
                    setIsSelectOpened(e)
                }}
                placeholder={t("Please select")}
                defaultValue={selectDefaultValues}
                value={selectDefaultValues}
                maxTagCount={4}
                style={{width: '100%',marginTop:'12px',whiteSpace:'nowrap'}}
                options={arrayPages}
                dropdownRender={(menu => {
                    return (
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            maxHeight: '300px',
                            overflowX: 'hidden',
                            overflowY: 'auto'
                        }}>{
                            arrayPages.map((item:any) => (
                                <div key={item.key} className='flex-row-vertical-center hovered'
                                     data-key={item.key}
                                     onClick={onSelectPageItemClicked}
                                     style={{height: '34px', lineHeight: '34px', padding: '0 8px'}}>
                                    {/*<img className='img-mini-small mr-8'*/}
                                    {/*     style={{display: (item.key == "all" || item.extra) ? "none" : 'inherit'}}*/}
                                    {/*     src={imgPathPerfix() + "page_black.png"}/>*/}
                                    <span style={{flexGrow: '1',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{item.title}</span>
                                    <Checkbox style={{flexShrink:'0'}} checked={item.isChecked}/>
                                </div>
                            ))
                        }
                        </div>
                    )
                })}
            />

            <div className='flex-row-vertical-center' style={{padding:'16px 0px 0px 16px',justifyContent:'flex-end',alignItems:'flex-end'}}>
                <span className='button-no-border flex-center cursor-pointer' onClick={props.onClosePopover} style={{
                    height: '32px',
                    padding: '0px 1px 2px 1px',
                    minWidth: '100px'
                }}>{t("Cancel")}</span>
                <div className='button-solid-style flex-center' onClick={() => {
                    props.onDoneEvent(getSelectedPages(),exportType);
                }} style={{height: '32px', padding: '0px 1px 2px 1px', minWidth: '70px',marginRight:'0px'}}>{t("Done")}</div>
            </div>
        </div>

    )
})

export default PopverExport;